<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M21.5 8.9h-2.3l-.7-1.7a4 4 0 0 0-4-2.7h-5a4 4 0 0 0-4 2.8l-.7 1.6H2.5q-.5 0-.5.6l.2.9q.2.3.5.3h.8q-.8.8-.9 2v1.8q0 1 .6 1.6v2.1q.1 1.2 1.3 1.3h1.2Q7 19.3 7 18.3V17h10v1.3q.2 1 1.2 1.2h1.3q1.1-.2 1.2-1.2V16q.6-.7.7-1.6v-1.9q0-1.1-.9-1.8h.8q.3 0 .5-.4l.2-1q0-.4-.5-.5M7.8 8.2Q8.4 7 9.5 7h5q1.1 0 1.7 1.2l.8 2H7zm-2 6.3q-1.2 0-1.3-1.3 0-1.1 1.2-1.2c.8 0 2 1.1 2 1.9s-1.2.6-2 .6m12.4 0c-.7 0-1.8.1-1.8-.6 0-.8 1.1-1.9 1.8-1.9q1.3 0 1.3 1.2 0 1.3-1.3 1.3"
    />
  </svg>
</template>
